import { FC, InputHTMLAttributes, useMemo } from 'react'
import styles from 'components/atoms/inputs/FutureInput/FutureInput.styl'
import cn from 'classnames'
import { useInputTheme } from 'components/features/theme/useInputTheme'

export type FutureInputProps =
  & InputHTMLAttributes<HTMLInputElement>
  & {
    name: string
    innerRef?: (instance: HTMLInputElement) => void
  }

export const FutureInput: FC<FutureInputProps> = (props) => {
  const { innerRef, className, name, disabled, ...restProps } = props

  const { inputActive, inputError, inputDisabled } = useInputTheme()
  const resultDisabled = disabled !== undefined ? disabled : inputDisabled

  const inputClassName = useMemo(() => {
    return cn(
      styles.genericInput,
      {
        [styles.active]: inputActive,
        [styles.error]: inputError,
      },
      className
    )
  }, [className, inputActive, inputError])

  return (
    <input
      { ...restProps }
      className={ inputClassName }
      disabled={ resultDisabled }
      ref={ innerRef }
    />
  )
}

